import * as React from "react";

interface CreateGenericContextProps<T> {
  initialContext?: T | undefined;
  errorMessage?: string;
}

export default function createGenericContext<T>({
  initialContext,
  errorMessage,
}: CreateGenericContextProps<T>) {
  const GenericContext = React.createContext(initialContext);

  const useGenericContext = () => {
    const expectedContext = React.useContext(GenericContext);

    if (!expectedContext) {
      const message = errorMessage
        ? errorMessage
        : "useGenericContext - Can not provide a context to use. Please make sure you have defined a context to be consumed.";

      throw new Error(message);
    }

    return expectedContext;
  };

  const GenericContextConsumer: React.FC<{
    children(props: T): React.ReactElement;
  }> = ({ children }) => {
    const expectedContext = useGenericContext();

    return children(expectedContext);
  };

  return {
    useGenericContext,
    GenericContextProvider: GenericContext.Provider,
    GenericContextConsumer,
  };
}
